import React from 'react';
import { UsersIcon, EuroIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardFooter } from './Card';
import { Button } from './Button';
interface TableOptionProps {
  id: string;
  name: string;
  capacity: number;
  price: number;
  minimumSpend?: number;
  description: string;
  selected?: boolean;
  onSelect: () => void;
}
export const TableOption = ({
  id,
  name,
  capacity,
  price,
  minimumSpend,
  description,
  selected = false,
  onSelect
}: TableOptionProps) => {
  return <Card variant={selected ? 'elevated' : 'outlined'} className={`mb-4 ${selected ? 'border-2 border-gray-800' : ''}`} data-id="element-122">
      <CardHeader title={name} data-id="element-123" />
      <CardContent data-id="element-124">
        <div className="p-2 border border-dashed border-gray-300 rounded-md mb-3" data-id="element-125">
          <div className="flex justify-between mb-2" data-id="element-126">
            <div className="flex items-center" data-id="element-127">
              <UsersIcon className="h-4 w-4 mr-1 text-gray-700" data-id="element-128" />
              <span className="text-sm text-gray-700" data-id="element-129">
                Capacity: {capacity}
              </span>
            </div>
            <div className="flex items-center" data-id="element-130">
              <EuroIcon className="h-4 w-4 mr-1 text-gray-700" data-id="element-131" />
              <span className="text-sm text-gray-700" data-id="element-132">{price}€</span>
            </div>
          </div>
          {minimumSpend && <div className="text-sm text-gray-600" data-id="element-133">
              Minimum spend: {minimumSpend}€
            </div>}
        </div>
        <p className="text-sm text-gray-600" data-id="element-134">{description}</p>
      </CardContent>
      <CardFooter data-id="element-135">
        <Button variant={selected ? 'primary' : 'secondary'} onClick={onSelect} className="w-full" data-id="element-136">
          {selected ? 'Selected' : 'Select Table'}
        </Button>
      </CardFooter>
    </Card>;
};